module.exports = {
  setApiKey: () => null,
  Queue: function() {
    return {};
  },
  KinesisClient: function() {
    return {};
  },
};
